export default "__VITE_ASSET__BU4h73aF__"